module.exports = __webpack_public_path__ + "img/bg.973b845.png";